(function($){

	$('input[type="checkbox"][data-switch]').each(function(){

		var input   = $(this);
		var options = $('[data-switch-group="' + input.data('switch') + '"]');

		input.on('change load', function(){
			if (input.is(':checked')) {
				options.removeAttr('checked', false);
			}

			input.attr('checked', true);
		});

		options.on('change', function(){
			var noneChecked = true;

			options.each(function(){
				if ($(this).is(':checked')) {
					noneChecked = false;
					return false;
				}
			});

			input.attr('checked', noneChecked);
		})

	});

})(jQuery);
